import { LeaseRecordType } from '@business-rules/lease/lease-record-type.helper';

export function getIconForLeaseRecordType(leaseRecordTypeDesc: LeaseRecordType) {
  switch (leaseRecordTypeDesc) {
    case LeaseRecordType.PartialLeaseComp:
      return 'partial_lease_comp';
    case LeaseRecordType.LeaseComp:
      return 'lease_comp';
    case LeaseRecordType.TenantNoComp:
      return 'tenant_no_comp';
    case LeaseRecordType.Tenant:
      return 'owner_occupied';
  }
}
